import { Component, ElementRef, Inject, Input, OnChanges, OnInit } from '@angular/core';

import { WINDOW } from '@page2flip/core';
import { Dimensions, Features } from '@page2flip/core/common';
import { environment } from '../../../../environments/environment';
import { ConfigurationHolder } from '../../../core/services/configuration-holder.service';
import { DocumentService } from '../../../core/services/document.service';
import { FeatureLoader } from '../../../core/services/feature-loader.service';
import { ImageLoader } from '../../../core/services/image-loader.service';
import { Storage } from '../../../core/services/storage.service';
import { TrackingService } from "../../../core/services/tracking.service";

@Component({
  selector: 'p2f-page-preview',
  templateUrl: './page-preview.component.html',
  styleUrls: ['./page-preview.component.css']
})
export class PagePreviewComponent implements OnInit, OnChanges {

  @Input() dimensions: Dimensions;
  @Input() fullWidth: boolean;
  @Input() pageNumber: number;

  private element: HTMLDivElement;

  features: Features;
  hasNote: boolean;
  isBookmarked: boolean;
  pageNote: string;

  constructor(@Inject(WINDOW) private window: any,
              private config: ConfigurationHolder,
              private doc: DocumentService,
              private elementRef: ElementRef,
              private feature: FeatureLoader,
              private trackingService: TrackingService,
              private loader: ImageLoader,
              private storage: Storage) {
    this.features = config.features;
    this.element = elementRef.nativeElement;
  }

  ngOnInit() {
    this.storage.bookmarks.subscribe(() => this.isBookmarked = this.storage.isBookmarked(this.pageNumber));
    this.storage.notes.subscribe(() => {
      this.hasNote = this.storage.hasNote(this.pageNumber);
      this.pageNote = this.storage.getNote(this.pageNumber);
    });

    this.setDimensions();
  }

  ngOnChanges() {
    this.setDimensions();
  }

  private setDimensions() {
    if (this.dimensions) {
      this.element.style.width = this.fullWidth ? 'calc(100% - 20px)' : this.dimensions.width + 'px';
      this.element.style.height = this.dimensions.height + 'px';
    }
  }

  getPageImage(): string {
    return this.loader.getPageImage(this.pageNumber, 250);
  }

  gotoPage() {
    this.doc.resetZoom();
    this.doc.gotoPage(this.pageNumber);
  }

  download() {
    const url: string = this.window.location.origin + this.window.location.pathname + this.doc.publication.pdf.file;
    const downloadUrl = `${environment.pdfApiUrl}?s=${url}&p=${this.pageNumber}`;
    this.window.open(downloadUrl);
    this.trackingService.trackEvent({ category: 'download', action: 'single', custom1: this.pageNumber.toString() });
  }

  bookmark() {
    this.storage.toggleBookmark(this.pageNumber);
  }

  note() {
    this.feature.load('note', this.pageNumber);
    // TODO: add GA event
  }

}
